export default "__VITE_ASSET__d719720f__"